import React from 'react';
import { LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
const linkClass = 'break-all font-serif text-2xl text-forest transition-colors duration-150 hover:text-wheat-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest md:text-3xl';
export function ContactDetails() {
  return <dl className="max-w-3xl" data-id="element-106" data-mp="h79jc2luzffa">
      <div className="grid gap-2 border-t border-rule py-7 sm:grid-cols-[10rem_1fr] sm:items-baseline" data-id="element-107" data-mp="h6hwbg6buq0m">
        <dt className="flex items-center gap-2 text-sm text-charcoal-muted" data-id="element-108" data-mp="d67jpko151cs">
          <MailIcon className="h-4 w-4 text-wheat-dark" aria-hidden="true" data-id="element-109" data-mp="qwjdrp46da6k" />
          Email
        </dt>
        <dd data-id="element-110" data-mp="lzb4ke108ghg">
          <a href={`mailto:${contact.email}`} className={linkClass} data-id="element-111" data-mp="lzjga2le5fr2">
            {contact.email}
          </a>
        </dd>
      </div>
      <div className="grid gap-2 border-t border-rule py-7 sm:grid-cols-[10rem_1fr] sm:items-baseline" data-id="element-112" data-mp="vx7dr0adt1cx">
        <dt className="flex items-center gap-2 text-sm text-charcoal-muted" data-id="element-113" data-mp="d4cp9ph590kf">
          <PhoneIcon className="h-4 w-4 text-wheat-dark" aria-hidden="true" data-id="element-114" data-mp="d6fpt3fxac3e" />
          Telephone
        </dt>
        <dd data-id="element-115" data-mp="m4rciudo4pqk">
          <a href={contact.phoneHref} className={`${linkClass} tabular-nums`} data-id="element-116" data-mp="m49je6mayrmv">
            {contact.phoneDisplay}
          </a>
        </dd>
      </div>
      <div className="grid gap-2 border-t border-rule py-7 sm:grid-cols-[10rem_1fr] sm:items-baseline" data-id="element-117" data-mp="r55lcen3g3pn">
        <dt className="flex items-center gap-2 text-sm text-charcoal-muted" data-id="element-118" data-mp="w2p1jk3cqqk8">
          <LinkedinIcon className="h-4 w-4 text-wheat-dark" aria-hidden="true" data-id="element-119" data-mp="110qqglnglk3m" />
          LinkedIn
        </dt>
        <dd data-id="element-120" data-mp="15tjxxhabb6je">
          <a href={contact.linkedinUrl} target="_blank" rel="noreferrer" className="break-all text-lg text-forest underline decoration-rule underline-offset-4 transition-colors duration-150 hover:decoration-forest" data-id="element-121" data-mp="15uuzdagac27c">
            {contact.linkedinDisplay}
          </a>
        </dd>
      </div>
      <div className="grid gap-2 border-y border-rule py-7 sm:grid-cols-[10rem_1fr] sm:items-baseline" data-id="element-122" data-mp="1jst55rgjiqb8">
        <dt className="flex items-center gap-2 text-sm text-charcoal-muted" data-id="element-123" data-mp="3ftlemtxw6w87">
          <MapPinIcon className="h-4 w-4 text-wheat-dark" aria-hidden="true" data-id="element-124" data-mp="3ay61633sr2cb" />
          Location
        </dt>
        <dd className="text-lg text-charcoal" data-id="element-125" data-mp="3pmsgw5xc5w42">{contact.location}</dd>
      </div>
    </dl>;
}